import titleStyles from '../../shared/Title.module.css';

interface IDrawInfoProps {
  title?: string;
  description?: string;
  includes?: JSX.Element | string;
}

const DrawInfo = ({ title, description, includes }: IDrawInfoProps) => {
  return (
    <div>
      {title && <p className={titleStyles.infoTitle}>{title}</p>}
      {description && (
        <div
          dangerouslySetInnerHTML={{ __html: description }}
          className={titleStyles.infoDescription}
        />
      )}
      {includes && (
        <div>
          <p className={`${titleStyles.infoTitle} ${titleStyles.alignLeft}`}>
            Includes:
          </p>
          <div
            className={`${titleStyles.infoDescription} ${titleStyles.alignLeft}`}
            dangerouslySetInnerHTML={{ __html: includes }}
          />
        </div>
      )}
    </div>
  );
};

export default DrawInfo;
